enum MessageColor {
    success = "#31b931",
    error = "#FF0000"
}
export default MessageColor;